// -*- coding: utf-8 -*-
// Generated by scripts/generate_from_specs.py
// Levels

export default {
    BASIC_SKILLS: "H64ZOHfi",
    LOWER_PRIMARY: "wnarlxKo",
    LOWER_SECONDARY: "eLt0Mbu4",
    PRESCHOOL: "FOhG0ib",
    PROFESSIONAL: "ZrgBU73s",
    TERTIARY: "FYxwbxts",
    UPPER_PRIMARY: "BkGYi3lD",
    UPPER_SECONDARY: "ZEjiwvOb",
    WORK_SKILLS: "Z#97dvst",
};
